var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconEdit = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.624 5.948.428.428a.847.847 0 0 1 0 1.201l-1.03 1.035-1.634-1.633 1.031-1.031a.847.847 0 0 1 1.201 0h.004zm-8.191 6.99 4.754-4.758 1.633 1.633-4.758 4.754a.848.848 0 0 1-.368.216l-2.073.592.592-2.073a.848.848 0 0 1 .216-.368l.004.004zm5.785-8.191-6.99 6.986a2.531 2.531 0 0 0-.648 1.102l-1.013 3.543a.85.85 0 0 0 1.052 1.052l3.543-1.013a2.56 2.56 0 0 0 1.101-.649l6.99-6.986a2.55 2.55 0 0 0 0-3.607l-.428-.428a2.55 2.55 0 0 0-3.607 0zm-10.1 1.381A3.118 3.118 0 0 0 4 9.246v9.636A3.118 3.118 0 0 0 7.118 22h9.636a3.118 3.118 0 0 0 3.118-3.118v-3.968c0-.47-.38-.85-.85-.85-.472 0-.85.38-.85.85v3.968c0 .783-.635 1.417-1.418 1.417H7.118A1.417 1.417 0 0 1 5.7 18.882V9.246c0-.783.634-1.417 1.417-1.417h3.968c.47 0 .85-.38.85-.85 0-.472-.38-.85-.85-.85H7.118z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-edit.7069dd47.svg";
export { ForwardRef as ReactComponent };